<template>
  <div class="tw-transition tw-border tw-border-gray dark:tw-border-dm-gray tw-rounded-3xl tw-bg-light dark:tw-bg-dm-light">
    <div class="tw-flex tw-p-6 tw-items-center">
      <div
        class="tw-flex-shrink-0 tw-w-8 tw-h-8 tw-rounded-full tw-mr-3 tw-flex tw-items-center tw-justify-center tw-font-bold"
        :class="getStatusHumanOrderClasses()"
      >
        <icon-check
          v-if="currentStatus?.human_order > status.human_order"
          class="tw-w-4"
        />
        <span v-else>
          {{ status.human_order }}
        </span>
      </div>

      <strong class="tw-text-xl tw-font-bold">
        {{ status.status_type_name }}
      </strong>
    </div>

    <div class="tw-p-6 tw-pt-0 tw-flex tw-flex-col tw-gap-3">
      <ForeignerPermitActionDate
        v-for="actionDate in status.action_dates"
        :key="actionDate.id"
        :permit="permit"
        :status-id="status?.id"
        :action-date="actionDate"
        :is-closest="closestActionDate && actionDate.id === closestActionDate.id"
      />
    </div>
  </div>
</template>

<script>
import ForeignerPermitActionDate from '@/components/Foreigner/Permits/ForeignerPermitActionDate.vue';

export default {
  components: {
    ForeignerPermitActionDate,
  },
  props: {
    status: {
      type: Object,
      required: true,
    },
    permit: {
      type: Object,
      required: true,
    },
    closestActionDate: {
      type: Object,
      default: undefined,
    },
    currentStatus: {
      type: Object,
      default: undefined,
    },
  },
  methods: {
    getStatusHumanOrderClasses() {
      if (this.currentStatus?.human_order > this.status.human_order) {
        return 'tw-bg-universal tw-text-white';
      }
      if (this.currentStatus?.human_order === this.status.human_order) {
        return 'tw-bg-primary tw-text-white';
      }
      if (this.currentStatus?.human_order < this.status.human_order) {
        return 'tw-bg-white tw-text-status-upcoming';
      }
    },
  },
};
</script>
